import { useCallback, useRef } from 'react'
import { ChevronDownThinIcon } from 'src/components/Icons/ChevronDownThinIcon'

import type { KitlookSkuOption } from './KitlookSkuOptionsMenu'
import { KitlookSkuOptionsMenu } from './KitlookSkuOptionsMenu'

export type { KitlookSkuOption }

interface KitlookSkuSelectorRowProps {
  label: string
  value: string
  hasOnlyOne: boolean
  options: KitlookSkuOption[]
  showSizeGuide: boolean
  onOpenSizeGuide: () => void
  isOpen: boolean
  onToggle: () => void
  onClose: () => void
  onSelect: (skuId: string) => void
  selectedSku: string | null
}

export function KitlookSkuSelectorRow({
  label,
  value,
  hasOnlyOne,
  options,
  showSizeGuide,
  onOpenSizeGuide,
  isOpen,
  onToggle,
  onClose,
  onSelect,
  selectedSku,
}: KitlookSkuSelectorRowProps) {
  const triggerRef = useRef<HTMLDivElement>(null)
  const isSingleValue = value.toLowerCase() === 'único'
  const displayText = isSingleValue
    ? `${label} único`
    : label
    ? `${label}: ${value}`
    : value

  const menuIsOpen = isOpen && !hasOnlyOne

  const handleSelect = useCallback(
    (skuId: string) => {
      onSelect(skuId)
      onClose()
    },
    [onClose, onSelect]
  )

  return (
    <>
      {showSizeGuide && (
        <button
          type="button"
          onClick={onOpenSizeGuide}
          className="w-fit border-none bg-transparent text-sm font-medium text-primaryBlue"
        >
          Tabela de medidas
        </button>
      )}
      <div
        ref={triggerRef}
        className={`relative flex h-12 flex-col border border-checkoutInputBorder bg-white ${
          hasOnlyOne ? 'opacity-80' : 'cursor-pointer'
        }`}
      >
        <button
          type="button"
          onClick={() => !hasOnlyOne && onToggle()}
          disabled={hasOnlyOne}
          aria-expanded={menuIsOpen}
          aria-haspopup="true"
          className="flex h-full w-full items-center justify-between px-4"
        >
          <p className="line-clamp-1 text-sm font-normal text-neutral11">
            {displayText}
          </p>

          {!hasOnlyOne && (
            <div
              className={`transition-transform ${
                menuIsOpen ? 'rotate-180' : ''
              }`}
            >
              <ChevronDownThinIcon />
            </div>
          )}
        </button>

        {menuIsOpen && (
          <KitlookSkuOptionsMenu
            triggerRef={triggerRef}
            options={options}
            selectedSku={selectedSku}
            onSelect={handleSelect}
            onClose={onClose}
          />
        )}
      </div>
    </>
  )
}
